"use strict";

angular.module("vendor")
.directive("orderModelManagement", function() {
    return {
        bindToController: {
            dateFilter: "<?",
            statusFilterService: "<",
            contactTypeFilterService: "<"
        },
        restrict: "E",
        transclude: {
            "orderModelManagementSidebar": "?orderModelManagementSidebar",
            "orderModelManagementHeader": "?orderModelManagementHeader",
            "orderModelManagementTable": "orderModelManagementTable"
        },
        templateUrl: require("./order-model-management.directive.html"),
        controller: OrderModelManagementController,
        controllerAs: "orderModelManagementCtrl"
    };
});

function OrderModelManagementController(
    $scope, $state, StateExtensionService, UserService, ModalService, InvoiceService, gettextCatalog
) {
    $scope.sharedScope = $scope.$new();
    $scope.canInvoice = false;
    $scope.canModifyOrder = false;

    $scope.statusHelpTip = $scope.service.getStatusHtmlContent();
    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.statusHelpTip = $scope.service.getStatusHtmlContent();
    });

    $scope.$on("statusDateFilterUpdated", function(event, statusFilter) {
        StateExtensionService.updateUrlParams(statusFilter);
        angular.extend($scope.params, statusFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("dateFilterUpdated", function(event, dateFilter) {
        StateExtensionService.updateUrlParams(dateFilter);
        angular.extend($scope.params, dateFilter);
        $scope.$emit("clearSelection");
    });

    $scope.$on("orderContactTypeFilterUpdated", function(event, contactTypeFilter) {
        StateExtensionService.updateUrlParams(contactTypeFilter);
        angular.extend($scope.params, contactTypeFilter);
        $scope.$emit("clearSelection");
    });

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.canInvoice = user.info && user.info.can_invoice;
            $scope.canModifyOrder = user.vendor && user.vendor.allow_order_modification;
        }
    });

    $scope.seeOrder = function(order) {
        $state.go("orderDetails", {id: order.id});
    };

    $scope.createInvoice = function(orderId) {
        // noinspection JSVoidFunctionReturnValueUsed,EditorConfigEncoding
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Order Creation Confirmation"),
                    message: gettextCatalog.getString("Do you want to create an invoice with this order?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return
                }

                InvoiceService.create({
                    order: orderId
                }).then(function onSuccess(invoice) {
                    FlashBag.success(gettextCatalog.getString("Invoice was created successfully."), true);
                    $state.go('invoiceDetails', {id: invoice.id})
                });
            });
        });
    };

    $scope.startOrderModification = function(orderId) {
        VendorOrderService.startOrderModification(orderId);
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/model-management/order-model-management.directive.js
// module id = 836
// module chunks = 0